<template>
  <div class="openclass-list ">

    <!-- <div class="carousel-part clear">
      <div class="caurse-carousel fl">
        <template v-if="carouselPicData.length">
          <el-carousel
            :interval="5000"
            height="400px"
          >
            <el-carousel-item
              v-for="item in carouselPicData"
              :key="item.id"
            >
              <a
                :href="item.link_url"
                target="_blank"
                v-if="item.link_url"
              >
                <img :src="BASE_URL + item.picture" />
              </a>
              <a v-else><img :src="BASE_URL + item.picture" /></a>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
      <div
        class="popularity-list fr"
        v-if="false"
      >
        <el-card
          class="box-card"
          shadow="never"
        >
          <div
            slot="header"
            class="clearfix"
          >
            <span class="humantitle">{{ $t('homepage.popularity') }}</span>
          </div>
          <template v-if="humanQiData.length">
            <div
              v-for="(item, index) in humanQiData"
              :key="item.id"
              class="text item humanItem"
            >
              <i :class="[(index + 1) < 4 ? 'humanNun yellowC' : 'humanNun']">{{ index + 1 }}</i>
              <a
                @click="turnDetails(item)"
                :title="item.video_name"
              >{{ item.video_name }}</a>
            </div>
          </template>
        </el-card>
      </div>
    </div> -->

    <div class="course-video-con maxW">
      <CommonCate @changeCateOption="changeCateOption" @changeOrderType="changeOrderType"  />

      <!-- <div class="filter-nav">
        <el-button
          type="text"
          :class="[orderType == 'time' ? 'blueC' : '']"
          @click="toggle_order('time')"
        >
          {{ $t('homepage.time') }}<i class="el-icon-sort-down"></i>
        </el-button>
        <el-button
          type="text"
          :class="[orderType == 'download' ? 'blueC' : '']"
          @click="toggle_order('download')"
        >
          热度<i class="el-icon-sort-down"></i>
        </el-button>
      </div> -->
      <ul class="course-video-list clear">
        <li
          class="course-video-li box"
          v-for="(item, index) of videoListData"
          :key="index"
        >
          <div class="video-thumbnail">
            <a @click="turnDetails(item)">
              <img
                :src="item.picture.indexOf('http') == -1 ? BASE_URL + item.picture : item.picture"
                :onerror="errorImg"
              />
            </a>
          </div>
          <div class="video-creater-info">
            <a
              @click="turnDetails(item)"
              :title="item.video_name"
            >{{ item.video_name }}</a>
            <div class="teacher-info clear">
              <!-- :src="BASE_URL + item.avatar_path" -->
              <!-- <img class="acatar_img" src="../../../assets/images/morentouxiang.png" /> -->
              <img
                class="acatar_img"
                :src="item.avatar_path"
              />
              <span>{{ item.custom_speaker }}</span>
              <div class="ecmapper fr">
                {{ item.clicks }}{{ $t('global.play') }}/{{ item.cate_name ? item.cate_name : $t('global.defaultSort')
                }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="pageBox">
        <el-pagination
          v-if="total_number > page_size"
          @current-change="change_page"
          :page-size="page_size"
          :current-page="page_index"
          layout="total,prev, pager, next,jumper"
          :total="total_number"
        ></el-pagination>
      </div>
    </div>
    <div
      class="dependent maxW"
      v-if="placeholder"
    >
      <i class="ipng image_state01"></i>
      <p>- {{ $t('global.noData') }} -</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoType: [],
      videoTypeId: 0, // 视频分类的高亮索引值
      placeholder: false,
      page_index: 1,
      page_size: 16,
      total_number: 0,
      orderType: "time",
      study_section_id: null,
      grade_id: null,
      subject_id: null,
      version_id: 0, //版本
      keyword: this.$route.query.keyword, //首页搜索跳转到此页面时带的关键字
      create_id: 0,
      orgList: [],
      orgLevel3: [],
      subjectList: [],
      errorImg:
        'this.src="' +
        require("../../../../public/images/image_loding.png") +
        '"',
      checked: false,
      subjectChecked: 0,
      gradeChecked: 0,
      orgChecked: 0,
      videoListData: [],
      carouselPicData: [],
      humanQiData: [],

      cateOptions: null,
    };
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
  },
  components: {
    CommonCate: () => import("@/components/common-v2/category.vue"),
  },
  created() {
    // this.getOrg();
    // this.getCarouselPic();
    // this.humanQi();
    // this.getVideoData();
  },
  mounted() {
    // this.getCarouselPic();
  },
  watch: {
    "$store.state.customerCate": {
      handler: function (nv) {
        // console.log("customerCate", nv);
        if (!['', null, undefined].includes(nv)) {
          this.videoTypeId = nv;
          this.page_index = 1;
          this.getVideoData();
        }
      },deep:true,immediate:true
    },
    "$route.query.keyword"(value) {
      this.keyword = value;
        this.page_index = 1;
        this.getVideoData();
    },
    subjectChecked(a, b) {
      if (a != b) {
        this.page_index = 1;
      }
    },
    gradeChecked(a, b) {
      if (a != b) {
        this.page_index = 1;
      }
    },
    orgChecked(a, b) {
      if (a != b) {
        this.page_index = 1;
      }
    },
  },
  methods: {
    changeCateOption(cateOptions) {
      this.cateOptions = cateOptions;
    },
    // 跳转到视频详情页
    turnDetails(item) {
      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll()
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          if (item.status_m3u8 == 1) {
            sessionStorage.setItem(
              "cateOptions",
              JSON.stringify(this.cateOptions)
            );
            this.$router.push({
              path: "openclassDetail",
              query: { id: item.id },
            });
          } else {
            let content = this.$t("homepage.transcoding");
            this.$alert(content, this.$t("global.tips"), {
              confirmButtonText: this.$t("global.sure"),
              callback: (action) => {
                return false;
              },
            });
          }
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: 1,
          type_id: item.id,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
        },
        func: { success },
      });
    },
    getVideoData() {
      let success = (res) => {
        this.videoListData = res.data.data;
        this.total_number = parseInt(res.data.data_sum);
        this.page_index = parseInt(res.data.page_index);
        this.placeholder = this.videoListData.length === 0;
        this.videoListData.forEach((item) => {
          if (!item.avatar_path.includes("http")) {
            item.avatar_path = this.BASE_URL + item.avatar_path;
          }
        });
      };
      this.$ajax({
        url: "/api/video/video_list",
        method: "get",
        params: {
          page_index: this.page_index,
          page_size: this.page_size,
          study_section_id: this.study_section_id,
          grade_id: this.grade_id,
          subject_id: this.subject_id,
          version_id: this.version_id,
          order_type: this.orderType,
          keyword: this.keyword,
          authority: 1,
          status: 1,
          cate_id: this.videoTypeId,
          is_limit: 1,
          type:1,// （0：公开课，1：高层讲堂；2：百万大单；3：客户培训）
        },
        func: {
          success,
        },
      });
    },
    //轮播图
    getCarouselPic() {
      let success = (res) => {
        this.carouselPicData = deep_clone(res.data);
      };
      this.$ajax({
        url: "api/carousel/banners",
        method: "get",
        params: {
          module: 4,
        },
        func: {
          success: success,
        },
      });
    },
    //人气
    humanQi() {
      let success = (res) => {
        this.humanQiData = res.data.data;
      };
      this.$ajax({
        url: "/api/video/video_list",
        method: "get",
        params: {
          page_index: 1,
          page_size: 10,
          order_type: "click",
          authority: 1,
          status: 1,
        },
        func: {
          success,
        },
      });
    },
    changeOrderType(type) {
      this.orderType = type;
      this.getVideoData();
    },
    //获取学段
    getOrg() {
      let params = {
        level: 2,
        pid: 1,
        direction: "balance",
        is_diffplat: 1,
      };
      const success = (res) => {
        this.orgList = res.data;
        this.orgList.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.getOrgLevel3(this.orgList[0].id);
        this.getVideoData();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    //获取年级
    getOrgLevel3(index, study_section_id) {
      this.orgChecked = index;
      let params = {
        level: 3,
        pid: study_section_id == 0 ? undefined : study_section_id,
        direction: "balance",
      };
      const success = (res) => {
        this.orgLevel3 = res.data;
        this.orgLevel3.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.getSubjectList(this.orgLevel3[0].id);
        (this.study_section_id = study_section_id), this.getVideoData();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    //获取学科
    getSubjectList(orgid, _index) {
      this.gradeChecked = _index ? _index : 0;
      let params = {
        type: 2,
        subject_id: orgid === orgid ? orgid : null,
        status: 1,
      };
      const success = (res) => {
        this.subjectList = res.data;
        this.subjectList.unshift({
          id: 0,
          name: this.$t("global.all"),
        });
        this.grade_id = orgid;
        this.getVideoData();
      };
      this.$ajax.get("api/cate/subject", {
        params: params,
        func: {
          success: success,
        },
      });
    },
    subjectChange(index, id) {
      this.subjectChecked = index;
      this.subject_id = id;
      this.getVideoData();
    },
    change_page(val) {
      this.page_index = val;
      this.getVideoData();
    },
  },
};
</script>
<style lang="scss">
.openclass-list .pageBox {
  margin-bottom: 20px;
}

.video-type {
  margin-top: 20px;
  padding: 23px 36px;
  font-size: 14px;
  background: #fff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  border-radius: 3px;

  > dt {
    margin-right: 14px;
    min-width: 72px;
    height: 30px;
    line-height: 30px;
    color: #888888;
  }

  > dd {
    float: left;
    margin-right: 30px;
    padding: 0 10px;
    line-height: 30px;
    cursor: pointer;

    &.active {
      color: #E62125;
      // background: #0059AA;
    }

    &:hover {
      color: #E62125;
    }
  }
}

.course-kard {
  padding: 20px 20px 13px 20px;
  background: #ffffff;
  margin: 0 0 40px;
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-top: 3px;
}

.course-content {
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 10px;
}

.course-content > span {
  display: block;
  float: left;
  color: #666666;
  width: 60px;
  overflow: hidden;
  height: 19px;
  text-align: left;
}

.course-content:last-of-type {
  margin-bottom: 0;
}

.course-list {
  margin-left: 60px;
  min-height: 29px;
}

.course-list > label {
  float: left;
  color: #000000;
  cursor: pointer;
  margin: 0 3.7735849057% 10px 0;
}

.course-list > label > input:checked + span {
  color: #E62125;
}

.course-list > label input {
  display: none;
}

.course-list > label:hover {
  color: #61a4f5;
}

.course-kard {
  margin: 20px 0;
  overflow: hidden;
}

.carousel-part {
  margin: auto;
  .caurse-carousel {
    display: inline-block;
    width: 100%;
    height: 400px;

    .el-carousel {
      border-radius: 3px;
    }

    .el-carousel__container {
      width: 100%;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: fill;
    }

    .el-carousel__indicator .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
  }

  .popularity-list {
    display: inline-block;
    width: 320px;
    background-color: #fff;

    .humantitle {
      // padding: 5px 8px;
      // border-radius: 2px;
      font-size: 14px;
      // color: #fff;
      // background-color: #338efc;
      color: #666;
      line-height: 18px;
    }

    .el-card__header {
      padding: 10px 17px 15px;
      // margin: 0 8px;
      border-bottom: solid 2px #e5e5e5;
      border-bottom: none;
    }

    .el-card__body {
      height: 299px;
      padding: 15px 20px 20px;
      padding: 0 17px;
      height: 355px;
    }

    .humanItem {
      padding: 5px 0;
    }

    .humanItem i {
      border-radius: 4px;
      vertical-align: middle;
    }

    .humanItem a {
      display: inline-block;
      width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 20px;
      font-size: 14px;
      color: #020202;
      vertical-align: middle;
    }

    .humanItem:hover {
      background-color: #effaff;
    }

    .humanItem:hover > a {
      color: #E62125;
    }

    .humanNun {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #ffffff;
      background: #d2d2d2;
      margin-right: 10px;
    }

    .humanNun.yellowC {
      background: #f2b732;
    }
  }
}

.course-video-con {
  margin: auto;
  margin-top: 9%;

  // .filter-nav {
  //   display: inline-block;
  //   padding: 10px;
  //   margin-top: 20px;
  //   margin-bottom: 20px;
  //   background: #fff;
  //   box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

  //   .el-button {
  //     line-height: 24px;
  //     font-size: 14px;
  //     color: #000;
  //     color: #727272;
  //     background: #fff;
  //     padding: 3px 5px;
  //     text-align: center;
  //   }

  //   .el-icon-sort-down {
  //     margin-left: 5px;
  //   }

  //   .cut {
  //     margin: 0 20px;
  //     color: #d2d2d2;
  //   }

  //   .blueC {
  //     color: #338efc;
  //     color: #fff;
  //     border-radius: 2px;
  //     background: #E62126;
  //   }

  //   .el-button + .el-button {
  //     margin-left: 5px;
  //   }
  // }
}

// .filter-nav {
//   .el-button {
//     font-size: 16px;
//     color: #000;
//   }
//   .el-icon-sort-down {
//     margin-left: 5px;
//   }
//   .cut {
//     margin: 0 20px 0 10px;
//     color: #d2d2d2;
//   }
//   .blueC {
//     color: #338efc;
//   }
// }

.course-video-list {
  .course-video-li {
    float: left;
    width: 290px;
    border-radius: 3px;
    // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin: 0 13px 20px 0;
    background: #fff;

    -moz-transition: all 0.35s ease-in;
    -webkit-transition: all 0.35s ease-in;
    -o-transition: all 0.35s ease-in;
    transition: all 0.35s ease-in;
    position: relative;

    .course-video-li .video-creater-info > a,
    .course-video-li .video-creater-info > p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .course-video-li:hover {
    -webkit-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  }

  .course-video-li .video-thumbnail {
    height: 140px;
    display: block;
    overflow: hidden;
  }

  .course-video-li .video-thumbnail a,
  .course-video-li .video-thumbnail img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }

  .video-thumbnail a {
    position: relative;
  }

  .video-thumbnail a::after {
    content: "";
    opacity: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.01) 2%,
      rgba(0, 0, 0, 0.2)
    );
    transition: opacity 0.4s ease-in-out;
    position: absolute;
    top: 2px;
    left: 0;
    width: 100%;
    height: 140px;
  }

  .video-thumbnail:hover > a:after {
    opacity: 1;
  }

  .course-video-li .video-creater-info {
    padding: 0 10px 20px;
    background: #ffffff;
  }

  .course-video-li .video-creater-info > a {
    font-size: 14px;
    color: #020202;
    line-height: 20px;
    padding-top: 13px;
    display: block;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .course-video-li .video-creater-info .course-video-li:hover {
    box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  }

  .course-video-li .video-creater-info {
    font-size: 16px;
    color: #666666;
  }

  .course-video-li:nth-of-type(4n) {
    margin: 0 0 18px 0;
  }

  .teacher-info {
    margin-top: 14px;
    height: 25px;
    line-height: 25px;
    font-size: 14px;

    > span {
      display: inline-block;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .acatar_img {
      display: inline-block;
      // vertical-align: middle;
      width: 25px;
      height: 25px;
      -moz-border-radius: 50%;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 5px;
    }

    .ecmapper {
      text-align: right;
      width: 115px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > div > span {
      font-size: 12px;
    }

    .collection08,
    strong {
      vertical-align: middle;
    }

    strong {
      margin-left: 5px;
    }
  }
}

.is-nice {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../../../assets/images/openclassQuality.png") no-repeat;
}

.dependent {
  // background-color: #fff;
  text-align: center;
  overflow: hidden;
  margin-bottom: 50px;
  padding-top: 30px;

  p {
    color: #999;
    margin: 40px 0;
  }
}
</style>
